const MaintenanceBanner = () => {
  return (
    <div className="row" style={{ marginTop: "-20px", width: "100%" }}>
      <div className="col-md-12">
        <style>{`.banner { 
          background-color: #FFCE46;
        color: #222;
        padding: 10px;
        text-align: center;
        font-weight: bold;
        font-size: 18pt;
            }
          `}</style>
        <div className="banner">
          LEAP will be unavailable on Friday, <u>26 June from 12:00 PM</u> and
          on <u>Saturday, June 27</u> due to scheduled maintenance. We apologise
          for any inconvenience caused.
        </div>
      </div>
    </div>
  );
};

const SlimEpaHeader = () => {
  return (
    <header className="header" aria-label="Site header">
      <nav
        className="navbar-expand-xl container-fluid container-t4-xl"
        aria-label="Header navigation"
        style={{ marginTop: "20px" }}
      >
        <div className="header__container">
          <a href="https://www.epa.ie/" className="navbar-logo">
            <img
              src="https://www.epa.ie/media/epa-2020/site-assets/images/logo/epawebnew.svg"
              alt="Environmental Protection Agency Logo"
            />
          </a>
        </div>
      </nav>
    </header>
  );
};

export { SlimEpaHeader };
